import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import OfflineIndicator from './components/OfflineIndicator';
import AiApp from './components/AiApp';
import VideoIntro from './components/VideoIntro';
import AiDoctor from './components/AiDoctor';
import UniqueFeature from './components/UniqueFeature';
import Partners from './components/Partners';
import Footer from './components/Footer';
import ContactUs from './components/ContactUs';
import PrivacyPolicy from './components/PrivacyPolicy';
import PressRelease from './components/PressRelease';

function HomePage() {
  return (
    <>
      <Hero />
      <OfflineIndicator />
      <AiApp />
      <VideoIntro />
      <AiDoctor />
      <UniqueFeature />
      <Partners />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/press" element={<PressRelease />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
